import { render } from "./event-form-info.vue?vue&type=template&id=55be80a5"
import script from "./event-form-info.vue?vue&type=script&lang=js"
export * from "./event-form-info.vue?vue&type=script&lang=js"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__